import { Button } from '@cokitchen/cokitchen-components';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowBackIcon } from 'assets/icons/arrow-back.svg';

type SingleBottomNavProps = {
  loading?: boolean;
  className?: string;
  buttonText?: string;
  btnDisabled?: boolean;
  btnClassName?: string;
  onConfirm?: () => void;
  backBtndisabled?: boolean;
};
const SingleBottomNav = ({
  loading,
  onConfirm,
  className = '',
  buttonText = 'Confirm',
  backBtndisabled,
  btnClassName = '',
  btnDisabled
}: SingleBottomNavProps) => {
  const navigate = useNavigate();
  return (
    <div className={`flex gap-4 justify-between py-5 mt-4 ${className}`}>
      <div
        className={`${
          backBtndisabled
            ? 'pointer-events-none cursor-not-allowed bg-opacity-50 text-opacity-40'
            : 'cursor-pointer'
        } inline-block w-9 h-9 bg-[#F5F4F4] px-[9px] text-[#B6AFAF] rounded-full hover:bg-gray-13 transition-all`}
        onClick={() => {
          if (!backBtndisabled) navigate(-1);
        }}>
        <div className='w-full flex justify-center items-center h-full'>
          <ArrowBackIcon className={`${!backBtndisabled ? 'text-gray-6' : 'text-gray-3'}`} />
        </div>
      </div>
      <div className='ml-auto'>
        <Button
          onClick={onConfirm}
          small
          variant='block'
          color='primary'
          className={`text-xs max-w-[150px] ${btnClassName}`}
          disabled={btnDisabled}
          loading={loading}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default SingleBottomNav;
